import { space } from '../spacing.js';
import { colors } from '../colors.js';
import { radii } from '../radius.js';
export const expandableRegion = {
    borderRadius: radii.x1_5,
    backgroundColor: colors.backgrounds.onGray,
    marginBottomHeader: space.x4,
    paddingRightLabel: space.x2,
};
//# sourceMappingURL=expandable-region.js.map